var CONFUSEDCORPORATE = CONFUSEDCORPORATE || {},
    CONFUSEDWEBSITE = CONFUSEDWEBSITE || {},
    CONFUSEDCORE = CONFUSEDCORE || {};

(function ($) {

    this.displayMainForm = function () {

        var self = this;

        // If not logged in, display Log In panel
        if (!self.IsAuthenticatedUser) {
            $('#LogInBanner').show();
        }

        $('#frmDetails').show();
        $('#MessageDetails').show();
    }

    this.redirectToLogin = function() {

        // Get the value out of the product drop-down
        var product = $('#querySelect').val();

        // Get the value out of the more information drop-down (if any)
        var moreInformation = $('#MoreInformation').val();

        // Get the url from the anchor
        var loginLink = $('#Login_Link').attr('href');

        // Add the first
        loginLink += '%3Fproduct%3D' + product;

        // Add the more information drop down if present
        if (moreInformation !== "") {
            loginLink += '%26moreInformation%3D' + moreInformation;
        }

        // Perform the redirect
        window.location.href = loginLink;
    }

    $(document).ready(function () {

        var querySelect = $('#querySelect');
        var moreInformationSelect = $('#MoreInformation');

        function DisplayMainFormInformation() {

            var self = this;

            // If not logged in, display Log In panel
            if (!self.IsAuthenticatedUser) {
                $('#LogInBanner').show();
            }

            $('#frmDetails').show();
            $('#MessageDetails').show();

        }

        // Set up event for when drop-down is selected
        $(querySelect).change(function(data) {
            // If the value of what has been selected required more information
            var selectionOption = $('option:selected', querySelect);

            if (selectionOption.attr('data-more-info') == "True") {
                $('#MoreInformationSection').show();
            } else {
                $('#MoreInformationSection').hide();
                displayMainForm();
            }
        });

        $(moreInformationSelect).change(function(data) {
            displayMainForm();
        });

        $('#Login_Link').on('click', function(e) {

            // Prevent the anchor redirecting
            e.stopPropagation();
            e.preventDefault();

            redirectToLogin();

        });

        $('#btnSubmit').click(function() {

            if ($('#frmBody').valid()
                && $('#title').valid()) {

                // Create the json object containing the data to send
                var DOB_Day = $('#daySelect').val();
                var DOB_Month = $('#monthSelect').val();
                var DOB_Year = $('#yearSelect').val();

                var DOB = DOB_Day + '/' + DOB_Month + '/' + DOB_Year;

                var formInformation = {
                    "Product": $('#querySelect').val(),
                    "MoreInformation": $('#MoreInformation').val(),
                    "Title": $('#title').val(),
                    "FirstName": $('#FirstName').val(),
                    "Surname": $('#Surname').val(),
                    "EmailAddress": $('#Email').val(),
                    "Postcode": $('#Postcode').val(),
                    "DateOfBirth": DOB,
                    "ContactPhoneQuestion": $('input[name=contactByPhone]:checked').val(),
                    "ContactPhoneNumber": $('#phone').val(),
                    "HasPurchased": $('#hasPurchased').val(),
                    "QuerySubject": $('#subject').val(),
                    "QueryDescription": $('#messageContents').val(),
                    "HttpAttributeReturnUrl": $('#returnUrl').val(),
                    "HttpAttributePriority": $('#HttpAttributePriority').val(),
                    "HttpAttributeOrigin": $('#HttpAttributeOrigin').val(),
                    "HttpAttributeExternal": $('#HttpAttributeExternal').val()


                };

                $.ajax({
                    url: '/api/contact-us/submit',
                    type: 'POST',
                    processData: false,
                    contentType: 'application/json; charset=utf-8',
                    dataType: 'json',
                    data: JSON.stringify(formInformation),
                    success: function(result) {

                        if (result.Success) {
                            // Redirect to configured Thank You page
                            var returnUrl = $('#returnUrl').val();
                            window.location.href = returnUrl;
                        } else {
                            // Display the error panel
                            $('#ErrorBanner').show();
                            $(document).scrollTop($("#ErrorBanner").offset().top);
                        }
                    }
                });
            } else {
                var height = $(window).height();
                $(document).scrollTop($(".label-error:visible:first").offset().top - (height / 2));
            }
        });
    });
})(window.jQuery);
